//
// RowStates.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import EventDispatcher from "../../../events/EventDispatcher";
import "../../../lib";

var RowStates = createModule("commons::RowStates", [], EventDispatcher, [
    {
        COLOR_CHANGED: 10047,
        EXCLUDED_CHANGED: 10046,
        SYMBOL_CHANGED: 10048,
        HIDDEN_CHANGED: 10044,
        LABELED_CHANGED: 10045,
        HIGHLIGHTED_CHANGED: 10049,
        SELECTED_CHANGED: 10043,
    },
    ,
    ,
    ,
    {
        toggleSelectedAtSpecifiedIndices: [0,[3]],
        areAnySelected: [2],
        setHighlightedAtSpecifiedIndices: [0,2,[3]],
        areAnyExcluded: [2],
        setExcludedOnlyAtSpecifiedIndices: [0,2,[3]],
        setExcludedAtSpecifiedIndices: [0,2,[3]],
        getExcludedIndices: [[3]],
        getNumberOfExcludedIndices: [4],
        getNumberOfHighlightedIndices: [4],
        areAnyHighlighted: [2],
        getNumberOfSelectedIndices: [4],
        getSelected: [[2]],
        setSelectedAtIndex: [0,2,4],
        getHighlightedIndices: [[3]],
        setExcludedAtIndex: [0,2,4],
        getExcluded: [[2]],
        getHighlighted: [[2]],
        setHighlightedAtIndex: [0,2,4],
        setHighlightedOnlyAtSpecifiedIndices: [0,2,[3]],
        getNumberOfRows: [4],
        getSelectedIndices: [[3]],
        setSelectedAll: [0,2],
        setSelectedOnlyAtSpecifiedIndices: [0,2,[3]],
        setSelectedAtSpecifiedIndices: [0,2,[3]],
    },
    {
        _create: [4,4],
    },
    ,
]);
export default RowStates;
